export const SCENE_NAME: string = 'Toilet';
export const TRACK_NUM: number = 0;
export const HELP_MENU_OPEN: boolean = false;